import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { validateDateAfter } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';
import { progressService } from '@/services/progress';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useProgressAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        cloneId: StringUtils.toNumber(route.params.id),
        name: '',
        fromTime: new Date(),
        toTime: new Date()
    });

    const validations = {
        name: { required },
        fromTime: { required, validateDate: validateDateAfter() },
        toTime: { required, validateDate: validateDateAfter('fromTime') }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.cloneId != null, // case: clone progress
        request: () => progressService.item.get(model.cloneId),
        onSuccess: ({ data }) => {
            model.cloneId = data.cloneId;
            model.name = data.name;
            model.fromTime = new Date(data.fromTime);
            model.toTime = new Date(data.toTime);
        },
        onError: () => router.push({ name: ROUTE_NAME_PROGRESS.ITEM.INDEX })
    });

    const create = crudAction.excuteAndNotify({
        validator: v$,
        request: () =>
            progressService.item.create(model.cloneId, model.name, model.fromTime.getTime(), model.toTime.getTime()),
        onSuccess: () => router.push({ name: ROUTE_NAME_PROGRESS.ITEM.INDEX })
    });

    return { model, v$, fetch, create };
}
